<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--School Select-->
<div class="MainMenu">
	<div class="Center2ColMenu">
		<label style="margin: 0">School:</label>

		<!-- 
        <select class="form-control" [(ngModel)]="SchoolID">
            <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">{{r.SchoolName}}</option>
        </select> 
        -->

		<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
	</div>
</div>

<!--Menu Top-->
<div class="MainMenu TopMargin">
	<div class="NameMenu">
		<label>First Name:</label>
		<input class="form-control" type="text" [(ngModel)]="FirstName" />

		<label>Middle Initial:</label>
		<input class="form-control MiddleInitial" type="text" maxlength="1" [(ngModel)]="MInitial" />

		<label>Last Name:</label>
		<input class="form-control" type="text" [(ngModel)]="LastName" />
	</div>

	<div class="Main2Grid">
		<!--L Col-->
		<div class="Grid2Col">
			<label>Title:</label>
			<input class="form-control" type="text" [(ngModel)]="Title" />

			<label>DOB:</label>
			<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="DOB" name="DOB"></p-calendar>

			<label>Gender:</label>
			<select class="form-control" [(ngModel)]="Gender">
				<option *ngFor="let r of lstGender" [ngValue]="r.ID">
					{{ r.Desc }}
				</option>
			</select>

			<label>Staff ID:</label>
			<input class="form-control" type="text" [(ngModel)]="StaffID" />
		</div>

		<!--R Col-->
		<div class="Grid2Col">
			<label>Staff Type:</label>
			<select class="form-control" [(ngModel)]="StaffType">
				<option *ngFor="let r of lstStaffType" [ngValue]="r.PersonTypeID">
					{{ r.PersonTypeDesc }}
				</option>
			</select>

			<label>SSN:</label>
			<input class="form-control" type="text" [(ngModel)]="SSN" />

			<label>Ethnicity</label>
			<select class="form-control" [(ngModel)]="Ethnicity">
				<option *ngFor="let r of lstEthnicity" [ngValue]="r.EthnicityID">
					{{ r.EthnicityDesc }}
				</option>
			</select>

			<label>Status</label>
			<select class="form-control" [(ngModel)]="Status">
				<option *ngFor="let r of lstStatus" [ngValue]="r.ID">
					{{ r.Desc }}
				</option>
			</select>
		</div>
	</div>
</div>

<!--Menu Bottom-->
<div class="MainMenu TopMargin">
	<div class="Grid4Col">
		<label>Address 1:</label>
		<input class="form-control" type="text" [(ngModel)]="Address1" />

		<label>Address 2:</label>
		<input class="form-control" type="text" [(ngModel)]="Address2" />
	</div>

	<div class="Grid6Col TopMargin">
		<label>City:</label>
		<input class="form-control" type="text" [(ngModel)]="City" />

		<label>State:</label>
		<input class="form-control StateText" type="text" maxlength="2" [(ngModel)]="State" />

		<label>Zip:</label>
		<input class="form-control ZipText" type="text" maxlength="10" [(ngModel)]="Zip" />
	</div>

	<div class="Grid4Col TopMargin">
		<label>Work Phone:</label>
		<input class="form-control" type="text" [(ngModel)]="WPhone" />

		<label>Cell Phone:</label>
		<input class="form-control" type="text" [(ngModel)]="CPhone" />

		<label>Home Phone:</label>
		<input class="form-control" type="text" [(ngModel)]="HPhone" />

		<label>Fax:</label>
		<input class="form-control" type="text" [(ngModel)]="Fax" />
	</div>

	<div class="Center2ColMenu TopMargin">
		<label>Email:</label>
		<input class="form-control" type="text" [(ngModel)]="Email" />
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
